<div class="illustration-absolute" [ngStyle]="styles">
  <div #ref>
    <qbe-illustration [name]="name" />
  </div>
</div>

<div class="illustration-absolute--placeholder" [ngStyle]="{ width: placeholderWidth, height: placeholderHeight }"></div>
